const loadScript = function(url){
	return new Promise((resolve,reject)=>{
		let scriptEl = document.createElement('script');
		scriptEl.setAttribute("async","async");
		scriptEl.addEventListener('load',(e)=>{
			console.log("load success");
			resolve({
				status: "success",
				url: url
			})
		})
		scriptEl.addEventListener('error',(e)=>{
			reject({
				status: "error",
				url: url
			})
		})
		scriptEl.src =url;
		document.body.appendChild(scriptEl);
	})
}
export { loadScript }